
<template>


  <div id="page-camera-view" >
       <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset"  allowfullscreen></iframe>
  </div>
    <!-- <iframe v-if="valid" width="100%" height="500" src="https://www.youtube.com/embed/GquEnoqZAK0?list=PL42HRt_UQaqrKELp5f-kVGjdtvEkI9WUe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <p class="ml-5 text-left mt-5">This camera will start streaming on its schedule</p>

    <br> -->
    <!-- {{CamName}} -->
<!--<session-modal></session-modal>-->
  </div>
</template>
<script>
import SessionModal from './SessionModal.vue'

import moment from 'moment'
import {GET_CAMERA_DETAILS, CAMERA_REPORT_MUTATION, SINGLE_USER,PLAY_CAMERA } from '@/graphql'

export default {
  components: {
    moment,
    SessionModal
  },
  data () {
    return {
      CamName:'',
      CamId:'',
      valid:false,
      currrent_schedule: {
        dates: {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
      },
      dataUserSchedule: {
        schedule: {
          scheduledates: {}
        }
      },
      current_schedule_dates: '',
      ddd: '',
      IframeSrc:'',
    }
  },
  computed:{
     reset () {
      // if (this.popupActive) {
        return this.IframeSrc
      // }
      //  if (!this.popupActive) {

      // }
    },
  },
  methods: {
     PalyCamera (id) {
      this.$apollo
        .mutate({
          mutation: PLAY_CAMERA,
          variables: {
            id:id
          }
        })
        .then(response => {
          if (response) {
            console.log(response)
            this.IframeSrc = response.data.playCamera.embed_code
          }
        }).catch(error => {
          console.log(error)
        })
    },
    getCameraDetails () {
      const CamId = this.$route.params.camId.slice(257, -257)
      this.$apollo
        .query({
          query: GET_CAMERA_DETAILS,
          variables: {
            id: CamId
          }
        }).then(response => {
          this.PalyCamera(response.data.getCameraDetail.code)
          this.CamName = response.data.getCameraDetail.name
          this.CamId = response.data.getCameraDetail.id
          this.createCameraWatchTimeReport()

        })

    },
    createCameraWatchTimeReport () {
      this.$apollo
        .mutate({
          mutation: CAMERA_REPORT_MUTATION,
          variables: {
            camera_id: this.CamId

          }
        })
        .then(response => {
          if (response.data.register.status == 'SUCCESS') {

            console.log('done')

          }
        }).catch(error => {

        })
    },
    CheckCondtion1 (scheduleDates) {
      ////Condition1: Check if child days exist in parent
      //days of parent
      const parentScheduleDays = []

      for (const i in this.dataUserSchedule.schedule.scheduledates) {
        const element = this.dataUserSchedule.schedule.scheduledates[i]

        if (element['start_time'] != '' && element['end_time'] != '') {
          if (parentScheduleDays.indexOf(element['day']) == -1) {
            parentScheduleDays.push(element['day'])
          }
        }
      }

      //days of child
      const childScheduleDays = []

      for (const i in scheduleDates) {
        const element = scheduleDates[i]

        for (const j in element) {
          // console.log( "element" );
          // console.log( element[j] );

          if (element[j]['start_time'] != '' && element[j]['end_time'] != '') {
            if (childScheduleDays.indexOf(i) == -1) {
              childScheduleDays.push(i)
            }
          }
        }
      }

      // console.log(parentScheduleDays)
      // console.log(childScheduleDays)

      const condition1 =
        childScheduleDays.filter((d) => !parentScheduleDays.includes(d))
          .length == 0

      const ddd = childScheduleDays.filter(
        (d) => !parentScheduleDays.includes(d)
      )
      this.ddd = ddd
      // console.log( 'ddd' )
      // console.log( ddd )

      ////End Condition 1
    },

    MergeUserScheduleSlots (UserData) {
      // console.log("UserData=")
      // console.log(UserData)

      //Change location format into nested format

      //let UserData = this.dataLocation.scheduledates

      //Nested format will be assigned to this variable
      const currentFormatSchedule = []

      for (const i in UserData.schedule.scheduledates) {
        const day = UserData.schedule.scheduledates[i].day

        if (typeof currentFormatSchedule[day] === 'undefined') {
          currentFormatSchedule[day] = []
        }

        currentFormatSchedule[day].push({
          start_time: UserData.schedule.scheduledates[i].start_time,
          end_time: UserData.schedule.scheduledates[i].end_time,
          ID: UserData.schedule.scheduledates[i].ID
        })
      }

      // console.log("currentFormatSchedule=")
      // console.log( currentFormatSchedule )

      // console.log("currentFormatScheduleEND=")

      ////Merge Current Format Slots
      const current_schedule_dates = []

      for (const day in currentFormatSchedule) {
        let current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in currentFormatSchedule[day]) {
          if (
            currentFormatSchedule[day][j].start_time != '' &&
            currentFormatSchedule[day][j].end_time != ''
          ) {
            const currentSlotStartTimeArray = currentFormatSchedule[day][
              j
            ].start_time.split(':')
            const currentSlotEndTimeArray = currentFormatSchedule[day][
              j
            ].end_time.split(':')

            const currentSlotStartTimeSeconds = parseInt(
              currentSlotStartTimeArray[0] * 60 * 60 +
                currentSlotStartTimeArray[1] * 60
            ) //current start time seconds
            const currentSlotEndTimeSeconds = parseInt(
              currentSlotEndTimeArray[0] * 60 * 60 +
                currentSlotEndTimeArray[1] * 60
            ) //current end time seconds

            for (
              let s = currentSlotStartTimeSeconds;
              s <= currentSlotEndTimeSeconds;
              s += 60
            ) {
              current_schedule_seconds_slots.push(s)
            }
          }
        }

        if (current_schedule_seconds_slots.length > 0) {
          current_schedule_seconds_slots = [...new Set(current_schedule_seconds_slots)].sort(function (a, b) {
            return a - b
          })

          // console.log(day)
          // console.log(current_schedule_seconds_slots)

          let startTime = current_schedule_seconds_slots[0]
          const endTime = ''
          // console.log(day)
          //  console.log(current_schedule_seconds_slots[0])
          for (const k in current_schedule_seconds_slots) {
            // console.log( current_schedule_seconds_slots[k] )
            // console.log( typeof( current_schedule_seconds_slots[k+1] ) )

            if (
              typeof current_schedule_seconds_slots[parseInt(k) + 1] ===
                'undefined' ||
              current_schedule_seconds_slots[parseInt(k) + 1] -
                current_schedule_seconds_slots[k] !=
                60
            ) {
              if (startTime != current_schedule_seconds_slots[k]) {
                current_schedule_dates[day].push({
                  start_time: startTime,
                  end_time: current_schedule_seconds_slots[k]
                })

                if (
                  typeof current_schedule_seconds_slots[parseInt(k) + 1] !==
                  'undefined'
                ) {
                  startTime = current_schedule_seconds_slots[parseInt(k) + 1]
                }
              }
            }
          }

          //current_schedule_seconds_slots

          //console.log( current_schedule_seconds_slots )
        }
      }

      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots

      return current_schedule_dates
    },

    MergeCurrentSlot (scheduleDates) {
      ////Merge Current Slots
      const current_schedule_dates = []
      for (const day in scheduleDates) {
        const current_schedule_seconds_slots = []
        current_schedule_dates[day] = []

        for (const j in scheduleDates[day]) {
          if (
            scheduleDates[day][j].start_time != '' &&
            scheduleDates[day][j].end_time != ''
          ) {
            const currentSlotStartTimeArray = scheduleDates[day][
              j
            ].start_time.split(':')
            const currentSlotEndTimeArray = scheduleDates[day][j].end_time.split(
              ':'
            )

            const currentSlotStartTimeSeconds = parseInt(
              currentSlotStartTimeArray[0] * 60 * 60 +
                currentSlotStartTimeArray[1] * 60
            ) //current start time seconds
            const currentSlotEndTimeSeconds = parseInt(
              currentSlotEndTimeArray[0] * 60 * 60 +
                currentSlotEndTimeArray[1] * 60
            ) //current end time seconds

            // for( let s = currentSlotStartTimeSeconds; s<= currentSlotEndTimeSeconds; s += 60 )
            // {
            //   current_schedule_seconds_slots.push( s )
            // }
            current_schedule_dates[day].push({
              start_time: currentSlotStartTimeSeconds,
              end_time: currentSlotEndTimeSeconds
            })
          }
        }
      }
      this.current_schedule_dates = current_schedule_dates

      // console.log( 'current_schedule_dates' )
      // console.log( current_schedule_dates )

      // return

      ////End Merging Current Slots
    },
    getCurrentPeriod () {
      const day = moment().format('dddd')
      const hr24 = moment(moment().format('LT'), ['h:mm A']).format('HH:mm')
      if (day == 'Monday') {
        this.currrent_schedule.dates.Monday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Tuesday') {
        this.currrent_schedule.dates.Tuesday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Wednesday') {
        this.currrent_schedule.dates.Wednesday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Thursday') {
        this.currrent_schedule.dates.Thursday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Friday') {
        this.currrent_schedule.dates.Friday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Saturady') {
        this.currrent_schedule.dates.Saturady.push({
          start_time: hr24,
          end_time: hr24
        })
      }
      if (day == 'Sunday') {
        this.currrent_schedule.dates.Sunday.push({
          start_time: hr24,
          end_time: hr24
        })
      }
    },
    getUserSchedule (user) {
      const user_schedule = []
      if (!user.schedule) {
        for (let i = 0; i < user.students.length; i++) {
          if (user.students[i].schedule) {
            for (let j = 0; j < user.students[i].schedule.scheduledates.length; j++) {
              // console.log(user.students[i].schedule)
              user_schedule.push(user.students[i].schedule.scheduledates[j])
            }
          } else {
            for (let j = 0; j < user.students[i].cameras.length; j++) {
              if (user.students[i].cameras[j].id == this.CamId) {
                if (user.students[i].cameras[j].schedule) {
                  for (let k = 0; k < user.students[i].cameras[j].schedule.scheduledates.length; k++) {
                    user_schedule.push(user.students[i].cameras[j].schedule.scheduledates[k])
                  }
                } else {
                  for (let k = 0; k < user.students[i].cameras[j].location.schedule.scheduledates.length; k++) {
                    user_schedule.push(user.students[i].cameras[j].location.schedule.scheduledates[k])
                  }
                }
              }
            }
          }
        }
      } else {
        for (let j = 0; j < user.schedule.scheduledates.length; j++) {
          user_schedule.push(user.schedule.scheduledates[j])
        }
      }
      this.dataUserSchedule.schedule.scheduledates = user_schedule
      // console.log(this.dataUserSchedule.schedule.scheduledates)
      this.CheckCondtion1(this.currrent_schedule.dates)
      this.MergeCurrentSlot(this.currrent_schedule.dates)
      const userMergedSlots = this.MergeUserScheduleSlots(this.dataUserSchedule)
      //   console.log(this.current_schedule_dates)
      //  console.log(userMergedSlots)
      ////Condition 2: check each slot
      const condition2 = true
      let totalCurrentSlotSlots = 0
      let validCurrentSlots = 0
      for (const day in this.current_schedule_dates) {
        for (const j in this.current_schedule_dates[day]) {
          if (
            this.current_schedule_dates[day][j].start_time != '' &&
              this.current_schedule_dates[day][j].end_time != ''
          ) {
            totalCurrentSlotSlots++

            const currentSlotStartTimeSeconds = this.current_schedule_dates[
              day
            ][j].start_time
            const currentSlotEndTimeSeconds = this.current_schedule_dates[day][
              j
            ].end_time

            for (const i in userMergedSlots[day]) {
              if (
                currentSlotStartTimeSeconds >=
                    userMergedSlots[day][i].start_time &&
                  currentSlotStartTimeSeconds <=
                    userMergedSlots[day][i].end_time
              ) {
                validCurrentSlots++
                break
              }
            }
          }
        }
      }
      // console.log(totalCurrentSlotSlots);
      // console.log(validCurrentSlots);
      // console.log(this.ddd)
      // condition2 = totalCurrentSlotSlots == validCurrentSlots

      //// End Condition 2
      if (
        totalCurrentSlotSlots == validCurrentSlots &&
          this.ddd.length == 0 &&
          totalCurrentSlotSlots + validCurrentSlots !== 0
      ) {
        //
        this.valid = true

      } else {
        //
        this.valid = false
      }
    },
    conditionMethod (role, id) {
      if (role == 'user') {
        this.$apollo
          .mutate({
            mutation: SINGLE_USER,
            variables: {
              id
            }
          })
          .then((response) => {
            // console.log(response)
            this.getCurrentPeriod()
            this.getUserSchedule(response.data.user)
          })
      }
    },
  

  },
  created () {
     console.log(this.$route.params.camId.slice(257, -257))
    // console.log(this.$route.params.camId)
    this.getCameraDetails()
    this.interval = setInterval(() => this.createCameraWatchTimeReport(), 60000)

      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId)


  }
}
</script>
